module.exports = __webpack_public_path__ + "30b1032279325ac4115d01ee4c6533a3.png";


//////////////////
// WEBPACK FOOTER
// ../images/welcome/sn-logo.png
// module id = 1158
// module chunks = 69